import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  value: "dark",
}



export const toggleSlice = createSlice({
    name: "toggle",
    initialState,
    reducers:{
        toggleBtn: (state)=>{
            state.value = state.value === 'dark' ? 'light' : 'dark'
        }
    }
})


// Action creators are generated for each case reducer function
export const { toggleBtn } = toggleSlice.actions

export default toggleSlice.reducer